import { toFormValidator } from "@vee-validate/zod";
import { z } from "zod";

import { i18n } from "@/i18n";

const { t } = i18n.global;

export const companyNordeaDictionarySuggestionLanguages = [
  "English",
  "Danish",
  "Finnish",
  "Norwegian",
  "Swedish"
] as const;
export const companyDanskeBankDictionarySuggestionLanguages = ["English", "Danish"] as const;

const getCompanyDictionarySuggestionSchema = (languages: readonly string[]) =>
  z.object({
    term: z.string().optional(),
    example: z.string().optional(),
    source: z.enum(languages as [string, ...string[]], {
      required_error: t("validation.company-dictionary-suggestion-required")
    }),
    email: z
      .string({
        required_error: t("validation.company-dictionary-suggestion-required")
      })
      .email(t("validation.email"))
  });

export const CompanyNordeaDictionarySuggestion = getCompanyDictionarySuggestionSchema(
  companyNordeaDictionarySuggestionLanguages
);
export const CompanyDanskeBankDictionarySuggestion = getCompanyDictionarySuggestionSchema(
  companyDanskeBankDictionarySuggestionLanguages
);

export type CompanyNordeaDictionarySuggestion = z.infer<typeof CompanyNordeaDictionarySuggestion>;
export type CompanyDanskeBankDictionarySuggestion = z.infer<typeof CompanyDanskeBankDictionarySuggestion>;

export const companyNordeaDictionarySuggestionFormValidator = toFormValidator(CompanyNordeaDictionarySuggestion);
export const companyDanskeBankDictionarySuggestionFormValidator = toFormValidator(
  CompanyDanskeBankDictionarySuggestion
);
